import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { Campaign, TimeConditionsType } from '../../../../services/model';
import { TimeWithoutSecondsPipe } from '../../../pipes/time-without-seconds.pipe';

@Component({
  selector: 'lib-campaign-time-conditions-details',
  templateUrl: './campaign-time-conditions-details.component.html',
  styleUrls: ['./campaign-time-conditions-details.component.scss'],
  imports: [NgOptimizedImage, TranslocoDirective, TimeWithoutSecondsPipe, DatePipe],
})
export class CampaignTimeConditionsDetailsComponent {
  campaign = input.required<Campaign>();

  lightFont = input(false);

  isSingleDay = computed<boolean>(() => {
    if (
      this.campaign().timeConditions?.timeConditionsType ==
      TimeConditionsType.PERIOD
    ) {
      return (
        this.campaign().timeConditions?.startDate === this.campaign().timeConditions?.endDate
      );
    }
    return false;
  });

  hasHours = computed<boolean>(() => {
    return (
      !!this.campaign().timeConditions?.startTime &&
      !!this.campaign().timeConditions?.endTime
    );
  });

  daysLeft = computed<number>(() => {
    if (
      this.campaign().timeConditions?.timeConditionsType ==
      TimeConditionsType.PERIOD
    ) {
      return this.getDaysLeft(this.campaign().timeConditions!.endDate!);
    }
    return 0;
  });

  private getDaysLeft(endDate: string): number {
    return Math.ceil(
      (new Date(endDate).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24)
    );
  }

  daysOfWeek = computed<string | undefined>((): string | undefined => {
    if (
      !this.campaign().timeConditions?.daysOfWeek ||
      this.campaign().timeConditions?.daysOfWeek!.length == 0
    ) {
      return undefined;
    }

    const weekDays = this.campaign().timeConditions?.daysOfWeek!;
    if (this.campaign().timeConditions?.daysOfWeek!.length == 1) {
      return this.transloco.translate(`weekDays.${weekDays[0]}`);
    } else {
      return weekDays
        .map((weekDay) => this.transloco.translate(`weekDays.${weekDay}_short`))
        .join(',');
    }
  });

  constructor(private transloco: TranslocoService) {}

  protected readonly TimeConditionsType = TimeConditionsType;
}
